var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.imageUrl)?_c('div',{staticClass:"Component image-wrapper-container",attrs:{"data-image-size":_vm.imageSize}},[(_vm.imageTitleHtml)?_c('h3',{domProps:{"innerHTML":_vm._s(_vm.imageTitleHtml)}}):_vm._e(),_c('img',{staticClass:"news-image",attrs:{"src":_vm.imageUrl,"alt":_vm.imageAlt}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }